/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1PaymentsKind } from './V1PaymentsKind'
import {
    V1PaymentsKindFromJSON,
    V1PaymentsKindFromJSONTyped,
    V1PaymentsKindToJSON,
    V1PaymentsKindToJSONTyped
} from './V1PaymentsKind'
import type { V1PaymentAassetKind } from './V1PaymentAassetKind'
import {
    V1PaymentAassetKindFromJSON,
    V1PaymentAassetKindFromJSONTyped,
    V1PaymentAassetKindToJSON,
    V1PaymentAassetKindToJSONTyped
} from './V1PaymentAassetKind'
import type { V1PaymentsStatus } from './V1PaymentsStatus'
import {
    V1PaymentsStatusFromJSON,
    V1PaymentsStatusFromJSONTyped,
    V1PaymentsStatusToJSON,
    V1PaymentsStatusToJSONTyped
} from './V1PaymentsStatus'

/**
 *
 * @export
 * @interface V1PaymentsTransaction
 */
export interface V1PaymentsTransaction {
    /**
     *
     */
    id: string
    /**
     *
     */
    txId?: string
    /**
     *
     */
    status: V1PaymentsStatus
    /**
     *
     */
    walletAddress: string
    /**
     *
     */
    kind: V1PaymentsKind
    /**
     *
     */
    assetKind: V1PaymentAassetKind
    /**
     *
     */
    amount: number
    /**
     *
     */
    comment?: string
    /**
     *
     */
    created: number
}

/**
 * Check if a given object implements the V1PaymentsTransaction interface.
 */
export function instanceOfV1PaymentsTransaction(
    value: object
): value is V1PaymentsTransaction {
    if (!('id' in value) || value['id'] === undefined) return false
    if (!('status' in value) || value['status'] === undefined) return false
    if (!('walletAddress' in value) || value['walletAddress'] === undefined)
        return false
    if (!('kind' in value) || value['kind'] === undefined) return false
    if (!('assetKind' in value) || value['assetKind'] === undefined)
        return false
    if (!('amount' in value) || value['amount'] === undefined) return false
    if (!('created' in value) || value['created'] === undefined) return false
    return true
}

export function V1PaymentsTransactionFromJSON(
    json: any
): V1PaymentsTransaction {
    return V1PaymentsTransactionFromJSONTyped(json, false)
}

export function V1PaymentsTransactionFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1PaymentsTransaction {
    if (json == null) {
        return json
    }
    return {
        id: json['id'],
        txId: json['txId'] == null ? undefined : json['txId'],
        status: V1PaymentsStatusFromJSON(json['status']),
        walletAddress: json['walletAddress'],
        kind: V1PaymentsKindFromJSON(json['kind']),
        assetKind: V1PaymentAassetKindFromJSON(json['assetKind']),
        amount: json['amount'],
        comment: json['comment'] == null ? undefined : json['comment'],
        created: json['created']
    }
}

export function V1PaymentsTransactionToJSON(json: any): V1PaymentsTransaction {
    return V1PaymentsTransactionToJSONTyped(json, false)
}

export function V1PaymentsTransactionToJSONTyped(
    value?: V1PaymentsTransaction | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        id: value['id'],
        txId: value['txId'],
        status: V1PaymentsStatusToJSON(value['status']),
        walletAddress: value['walletAddress'],
        kind: V1PaymentsKindToJSON(value['kind']),
        assetKind: V1PaymentAassetKindToJSON(value['assetKind']),
        amount: value['amount'],
        comment: value['comment'],
        created: value['created']
    }
}
